export default __webpack_public_path__ + "static/lemonPoppy-555086eb69138f06a14a3a9454097df6.webp";